import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    progressLabel: {
      position: 'absolute',
      fontSize: 14,
      fontWeight: 'normal',
      right: 9,
      bottom: SMALL_MARGIN,
      color: colorsPalette.gray,
      zIndex: 1,
    },
  }),
);
export default useStyles;
